<app-alert></app-alert>
<form [formGroup]="uploadFormFile" (ngSubmit)="onSubmit()" class="container mt-6">
  <div class="form-header">
    <h1>{{ 'global.support-category-management' | translate }}</h1>
  </div>

  <div formArrayName="rows">
    <div *ngFor="let row of rows.controls; let rowIndex = index" [formGroupName]="rowIndex" class="inputs-group">
      <ng-container *ngFor="let lang of languages">
        <img class="flag" [src]="'./../../../../../assets/images/support-page/flags/' + lang.flag" [alt]="lang.label" />
        <div class="input-wrapper">
          <input
            type="text"
            class="form-control"
            [formControlName]="lang.code"
            placeholder="{{ 'global.support-file-name' | translate }}" />
        </div>
      </ng-container>

      <button type="button" class="remove-row-btn" (click)="removeRow(rowIndex)">✖</button>
    </div>
  </div>

  <button type="button" class="buttons--btn-add" (click)="addRow()">
    <i class="agres-plus"></i>
    {{ 'global.to-add' | translate }}
  </button>

  <div class="buttons mt-5">
    <button class="buttons--btn-cancel" type="button" (click)="closeDialog()">
      <i class="agres-close"></i>
      {{ 'global.cancel' | translate }}
    </button>
    <button
      class="buttons--btn-save"
      type="submit"
      [disabled]="uploadFormFile.invalid"
      [ngClass]="{ 'btn-disabled': uploadFormFile.invalid }">
      <i class="agres-upload"></i>
      {{ 'global.save' | translate }}
    </button>
  </div>
</form>
